import React from "react";
import './DateField.css';
import {DateTime} from "luxon";
import ReactInput from "../../../services/packages/input-format/react/Input";
import {remFromPx} from "../../../services/utils/ui-commons";
import {BrowserOSType, getBrowserOSType} from "../../../services/utils/OSDetection";
import parseDigit from "../../../services/packages/input-format/parseDigit";
import {DISABLED_GRAY_PLEDGER_COLOR, PLEDGER_GREEN_COLOR} from "../../../services/utils/colors";


function formatDateValue(value,formatTemplate,template)
{
    let text = formatTemplate;

    for (let valueIndex=0,textIndex=0;textIndex<text.length;textIndex++) {
        if (text.charAt(textIndex) !== '/') {
            if (valueIndex < value.length) {
                text = text.substr(0, textIndex) + value.charAt(valueIndex) + text.substr(textIndex + 1);
                valueIndex++;
            }
        }
    }

    if (value.length>template.length) {
        text+=value.substr(8);
    }

    return { text, template: template }
}



/**
 * `input-format` `parse()` function.
 * https://github.com/catamphetamine/input-format
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string} value - The value parsed so far.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */
function parseDateCharacter(character, value)
{
    // Allow digits.
    return parseDigit(character)
}


/*
                  <DateField context={context} state={state.birthDay}
                               fontSize={dateFiledFontSize}
                               placeholder={'JJ/MM/AAAA'}
                               focus={state.currentField === 0}
                               onClickAction={KYC1NaissanceActions.FOCUS_CHANGED_ACTION.build(0)}
                               createOnChangeAction={KYC1NaissanceActions.BIRTH_DAY_CHANGED_ACTION.build}
                               enabled={true}
                               color={(isBirthDayValid || state.birthDay === '') ? DARK_BLUE_COLOR : '#D0021B'}
                    />

 */


/**
 * Input field for date
 */
export class DateField extends React.Component {


    computeFormatTemplate(props) {
        const context = this.props.context;
        const isPhone = context.appContext.isPhone;
        const formatType = this.props.formatType !== undefined ? this.props.formatType : 'DATE';
        switch (formatType) {
            case 'MONTH':
                this.formatTemplate = 'MM/AAAA';
                this.template = 'xx/xxxx';
                this.dateAddOnLength = 2;
                if (formatType!=='YEAR' && isPhone && BrowserOSType.IOS === getBrowserOSType()) {
                    this.inputType = 'month';
                }
                else {
                    this.inputType=undefined;
                }
                break;

            case 'YEAR':
                this.formatTemplate = 'AAAA';
                this.template = 'xxxx';
                this.dateAddOnLength = 4;
                this.inputType=undefined;
                break;

            case 'DATE':
            default:
                this.formatTemplate = 'JJ/MM/AAAA';
                this.template = 'xx/xx/xxxx';
                this.dateAddOnLength = 0;
                if (formatType!=='YEAR' && isPhone && BrowserOSType.IOS === getBrowserOSType()) {
                    this.inputType = 'date';
                }
                else {
                    this.inputType=undefined;
                }
                break;
        }
    }
    constructor(props) {
        super(props);
        this.computeFormatTemplate(props);
        this.state = {
            formattedValue: formatDateValue(this.props.state,this.formatTemplate,this.template).text
        }
    }

    componentDidUpdate(prevProps, prevState) {

        this.computeFormatTemplate(this.props);
        const formattedValue = formatDateValue(this.props.state,this.formatTemplate,this.template).text;
        let selectionPosition = 0;

        const editableLength=this.props.state.length-this.dateAddOnLength;
        if (editableLength > 0) {
            selectionPosition = editableLength;
        }

        if (this.formatTemplate.length>4) {
            if (editableLength >= 2) {
                selectionPosition++;
            }
            if (this.dateAddOnLength === 0 && editableLength >= 4) {
                selectionPosition++;
            }
        }

        if ((prevProps.focus !== this.props.focus) || (!this.focusSet)) {
            if (this.props.focus) {
                this.inputRef.focus();

                // setTimeOut Obligatoire sous Android
                setTimeout(() => {
                        const inputRef = this.inputRef;
                        if (inputRef !== null && this.inputType===undefined) {
                            inputRef.setSelectionRange(selectionPosition, selectionPosition)
                        }
                    }
                    , 5);

                //  this.inputRef.input.selectionStart = this.inputRef.input.selectionEnd = selectionPosition;
            }
        }
        this.focusSet = true;

        if (formattedValue !== this.state.formattedValue) {
            // on force le curseur à la fin de la zone de saisie : le timeout permet de contourner un bug dans Android
            setTimeout(() => {
                if (null !== this.inputRef && this.inputType===undefined) {
                    this.inputRef.setSelectionRange(selectionPosition, selectionPosition);
                }
            }, 5);
            this.setState({...this.state, formattedValue});
        }


    }

    render() {
        const context = this.props.context;
        const state = this.props.state;
        const isPhone = context.appContext.isPhone;
        const textAlign = this.props.textAlign===undefined ? 'right' : this.props.textAlign;
        const color = this.props.color ?? PLEDGER_GREEN_COLOR;
        const disabledColor = this.props.disabledColor ?? DISABLED_GRAY_PLEDGER_COLOR;

        // const drawBorderBottom = this.props.drawBorderBottom === undefined ? true : false;

        const style = {
            /*borderBottom: drawBorderBottom ? (this.props.enabled ? '1px solid #002538' : '1px solid #8C8C8C') : undefined,*/
            width: '100%',
            height: '100%'
        };

        const fontSize = this.props.fontSize === undefined ? 26 : this.props.fontSize;

        const inputStyle = {
            fontFamily: 'WorkSansVariableFont',
            fontSize: remFromPx(fontSize),
            backgroundColor: 'transparent',
            borderStyle: 'none',
            width: '100%',
            height: '100%',
            outline: 'none',
            color: this.props.enabled ? color : disabledColor,
            fontVariationSettings: '"wght" 400',
            margin: 0,
            textAlign: textAlign
        };

        const onInputRef = (input) => {
            this.inputRef = input;
        };

        const onChange = value => {
            context.dispatch(this.props.createOnChangeAction(value));
        };

        const onFocusContainer = (e) => {
            e.preventDefault();
            e.stopPropagation();
        }

        const onClick = (e) => {
            if (this.props.onClickAction) {
                context.dispatch(this.props.onClickAction);
            } else {
                if (this.props.onClick) {
                    this.props.onClick();
                }
            }
        };
        this.focusSet = false;

        const inputClass = this.props.inputClass !== undefined ? this.props.inputClass : 'DateInputClass';

        const readonly = this.props.readonly !== undefined ? this.props.readonly : false;

        const formatType = this.props.formatType !== undefined ? this.props.formatType : 'DATE';
        let dateAddOn;

        switch (formatType) {
            case 'MONTH':
                dateAddOn = this.props.defaultDay !== undefined ? this.props.defaultDay : '01';
                if (dateAddOn.length!==this.dateAddOnLength) {
                    dateAddOn='01';
                }
                break;

            case 'YEAR':
                dateAddOn = this.props.defaultMonthDay !== undefined ? this.props.defaultMonthDay : '0101';
                if (dateAddOn.length!==this.dateAddOnLength) {
                    dateAddOn='0101';
                }
                break;

            case 'DATE':
            default:
                dateAddOn = '';
                 break;
        }


        if (formatType!=='YEAR' && isPhone && BrowserOSType.IOS === getBrowserOSType()) {
            let dateValue;
            switch (formatType) {
                case 'MONTH':
                    dateValue = (state==='' || state===undefined) ? '' : DateTime.fromFormat(state, 'ddMMyyyy').toFormat('yyyy-MM');
                    break;

                case 'DATE':
                default:
                    dateValue = (state==='' || state===undefined) ? '' :  DateTime.fromFormat(state, 'ddMMyyyy').toFormat('yyyy-MM-dd');
                    break;
            }


            const onChangeDate = e => {
                const phoneValue = e.target.value;
                let inputValue='';
                switch (formatType) {
                    case 'MONTH': {
                        const srcDateTime = DateTime.fromFormat(phoneValue, 'yyyy-MM');
                        if (srcDateTime !== undefined && srcDateTime.isValid) {
                            inputValue = dateAddOn + srcDateTime.toFormat('MMyyyy');
                        }
                    }
                    break;

                    case 'DATE': {
                        const srcDateTime = DateTime.fromFormat(phoneValue, 'yyyy-MM-dd');
                        if (srcDateTime !== undefined && srcDateTime.isValid) {
                            inputValue = dateAddOn + srcDateTime.toFormat('ddMMyyyy');
                        }
                    }
                    break;

                    default:
                        inputValue=''; // unexpected case...
                }
                onChange(inputValue);
            };

            return (
                <div style={style}>
                    <input className={inputClass} style={inputStyle} type={this.inputType}
                           value={dateValue}
                           placeholder={this.props.placeholder} ref={onInputRef}
                           onClick={onClick}
                           onChange={onChangeDate}
                           disabled={!this.props.enabled}
                           readOnly={readonly}/>
                </div>
            );
        } else {
            const onChangeDate = value => {
                const dateValue = dateAddOn + value;
                onChange(dateValue);
            };

            let dateValue;
            switch (formatType) {
                case 'MONTH':
                    dateValue = (state === '' || state === undefined) ? '' : state.substring(2);
                    break;

                case 'YEAR':
                    dateValue = (state === '' || state === undefined) ? '' : state.substring(4);
                    break;

                case 'DATE':
                default:
                    dateValue = (state === '' || state === undefined) ? '' : state;
                    break;
            }

            return (
                <div style={style} onFocus={onFocusContainer}>
                    <ReactInput className={inputClass} style={inputStyle} type='text' value={dateValue}
                                placeholder={this.props.placeholder}
                                ref={onInputRef}
                                onClick={onClick}
                                onChange={onChangeDate}
                                disabled={!this.props.enabled}
                                readOnly={readonly}
                                pattern={isPhone ? '[0-9]*' : undefined}
                                inputMode={isPhone ? 'numeric' : undefined}
                                parse={parseDateCharacter}
                                format={value => formatDateValue(value,this.formatTemplate,this.template)}/>
                </div>
            );
        }
    }
}
